import { createAutocompleteDataSource } from "../common/data";
import * as Util from "../common/util";
import * as Data from "../interfaces/data";
import { ILanguage } from "../interfaces/translations";
import * as AppointmentData from "./appointmentData";

export interface ILookupData {
    Templates: Array<Data.ICodeModel<number>>;
    Inspectors: Array<Data.ICodeModel<number>>;
    MajorTick: number;
    TargetTemplate: ITargetTemplate;
    Target: ITarget;
    Languages: ILanguage[];
    DefaultLanguageID: number;
}

export interface ITargetTemplate {
    ID: number;
    TemplateName: string;
    URLFriendlyName: string;
    TargetTemplateTypeID: number;
    FormItems: ITargetTemplateFormItem[];
    AddressFormItems: ITargetTemplateFormItem[];
}

export interface ITargetTemplateFormItem {
    ID: number;
    FormText: string;
    IsRequired: boolean;
    MaxLength: number;
    Value: string;
    IsActive: boolean;
    ControlTypeID: number;
}

export interface ITargetFieldValue {
     Name: string;
     Value: string;
     ControlTypeID: number;
 }

export interface ITarget {
    TargetID: number;
    TargetTemplateID: number;
    TargetTemplateTypeID: number;
    Address: string;
    City: string;
    State: string;
    Zip: string;
    Phone: string;
    FieldValues: ITargetFieldValue[];
}

export interface IAppointmentLookupDataRequest {
    TargetID: number|null;
}

export interface ICreateAppointmentRequest {

    TemplateID: number;
    AssignedToUserID: number;
    TargetID: number;
    Timeframe: number;
    AppointmentDate: Date | null;
    StatusID: number;
    LanguageID: number;
}

export interface ITaskAutoAddRequest {
    TemplateID: number | null;
}

export function getAppointmentLookupData(request: IAppointmentLookupDataRequest): JQuery.Deferred<Data.IResponse<ILookupData>> {
    return Util.callWebService(
        "/api/AppointmentAdd/GetAppointmentLookupData",
        "POST",
        request);
}

export function getTargetTemplate(templateID: number): JQuery.Deferred<any, any, any> {
    return Util.callWebService(
        "/api/AppointmentAdd/GetTargetTemplate",
        "POST",
        templateID);
}

export interface IAutoCompleteParameters {
    SearchText: string;
    MaxRecords: number;
    TargetTemplateID: number;
    TargetTemplateTypeID: number;
}

export function getTargetAutocompleteData(customParameters: (data: IAutoCompleteParameters) => void): kendo.data.DataSource | null {
    if (!customParameters) {
        return null;
    }

    return createAutocompleteDataSource(
        "/api/AppointmentAdd/GetTargetAutocompleteData",
        customParameters);
}

export function createAppointment(request: ICreateAppointmentRequest): JQuery.Deferred<Data.IResponse<AppointmentData.IAppointment>> {
    return Util.callWebService(
        "/api/Appointment/CreateAppointment",
        "POST",
        request);
}

export function createDefaultAppointment(request: ITaskAutoAddRequest): JQuery.Deferred<Data.IResponse<AppointmentData.IAppointment>> {
    return Util.callWebService(
        "/api/AppointmentAdd/TaskAutoAdd",
        "POST",
        request);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/appointmentAddData.ts